module.exports = __webpack_public_path__ + "img/ic-logo.7e109bee.png";